import { useMemo, useState } from 'react';
import { Property } from 'models/Properties';
import { QuoteOverrides, QuoteAdjustment } from 'models/Quote';
import { PinCode } from 'models/PinCode';
import { Employee } from 'models/Employees';
import { Lead } from 'models/Leads';
import { ReviewByHost } from 'models/Reviews';
import { Tag } from 'models/Tags';
import { ChannelSettings } from 'models/Channels';
import BookingDotComAvailableActions from '../../../../models/ChannelActions';
import LeadModalContext from './LeadModalContext';

const LeadModalContextProvider = ({
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  availableProperties: initialAvailableProperties,
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  children,
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  modalId,
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  defaultLeadUid,
}) => {
  const [currentLeadUid, setCurrentLeadUid] = useState(
    defaultLeadUid as string,
  );
  const [apiError, setApiError] = useState<string>();
  const [availableEmployees, setAvailableEmployees] = useState<Employee[]>();
  const [availableProperties, setAvailableProperties] = useState<Property[]>(
    initialAvailableProperties,
  );
  const [availableTags, setAvailableTags] = useState<Tag[]>();
  const [lead, setLead] = useState<Lead>();
  const [leadTags, setLeadTags] = useState<Tag[]>();
  const [propertyFees, setPropertyFees] =
    useState<QuoteOverrides['fees']['otherFees']>();
  const [quoteAdjustments, setQuoteAdjustments] = useState<QuoteAdjustment[]>();
  const [pinCode, setPinCode] = useState<PinCode>();
  const [reviewByHost, setReviewByHost] = useState<ReviewByHost>();
  const [channelSettings, setChannelSettings] = useState<ChannelSettings[]>();
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const [overrides, setOverrides] = useState<QuoteOverrides>(null);
  const [availableBookingDotComActions, setAvailableBookingDotComActions] =
    useState<BookingDotComAvailableActions>();
  const [groupBookingLeads, setGroupBookingLeads] = useState<{
    mainLead: Lead;
    subLeads: Lead[];
    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  }>(null);

  const contextValue = useMemo(
    () => ({
      apiError,
      availableEmployees,
      availableProperties,
      availableTags,
      lead,
      leadTags,
      modalId,
      propertyFees,
      quoteAdjustments,
      pinCode,
      reviewByHost,
      overrides,
      setApiError,
      channelSettings,
      availableBookingDotComActions,
      groupBookingLeads,
      currentLeadUid,
      setAvailableEmployees,
      setAvailableProperties,
      setAvailableTags,
      setLead,
      setLeadTags,
      setPinCode,
      setReviewByHost,
      setChannelSettings,
      setPropertyFees,
      setQuoteAdjustments,
      setOverrides,
      setAvailableBookingDotComActions,
      setGroupBookingLeads,
      setCurrentLeadUid,
    }),
    [
      apiError,
      availableEmployees,
      availableProperties,
      availableTags,
      propertyFees,
      quoteAdjustments,
      lead,
      leadTags,
      modalId,
      pinCode,
      reviewByHost,
      overrides,
      availableBookingDotComActions,
      groupBookingLeads,
      currentLeadUid,
    ],
  );

  return (
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <LeadModalContext.Provider value={contextValue}>
      {children}
    </LeadModalContext.Provider>
  );
};

export default LeadModalContextProvider;
